export default "__VITE_ASSET__sqkMsXjQ__"